

























import { defineComponent, PropType, ref, watch, computed, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import { debounce } from 'lodash-es';
import AppImage from '~/components/partials/App/AppImage.vue';
import { DynamicPartsWraparoundImageText } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppImage,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsWraparoundImageText>,
      required: true,
    },
  },
  setup(props) {
    const annotation = ref<HTMLDivElement>();
    const wrapper = ref<HTMLDivElement>();
    const image = ref<InstanceType<typeof AppImage>>();

    // 画像の位置
    const layout = computed(() => {
      const imageHeight = image.value?.$el.clientWidth || 0;
      const wrapperHeight = wrapper.value?.clientWidth || 1;
      const ratio = imageHeight / wrapperHeight;

      if (ratio > 1 / 2) {
        return 'center';
      }

      return props.item.layout;
    });

    const resizeAnnotation = debounce(() => {
      if (!annotation.value || !image.value) return;

      annotation.value.style.width = `${image.value.$el.clientWidth}px`;
    }, 100);

    watch(image, resizeAnnotation);

    onMounted(() => {
      window.addEventListener('resize', resizeAnnotation);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', resizeAnnotation);
    });

    return { annotation, image, wrapper, layout };
  },
});
